module.exports = __webpack_public_path__ + "img/Group 1419 (1).7ae598c5.png";